import React from 'react'
import { compose, bindActionCreators } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import cx from 'classnames'
import _ from 'lodash'

import opacity from 'constants/opacity'
import { DELIVERY_TYPE_SHOP } from 'constants/merchant'
import takeawayIcon from 'assets/icons/bottomNavigation/takeaway.svg'
import deliveryIcon from 'assets/icons/bottomNavigation/delivery.svg'
import shopIcon from 'assets/icons/bottomNavigation/shop.svg'
import mapIcon from 'assets/icons/bottomNavigation/map.svg'
import takeawayDisabledIcon from 'assets/icons/bottomNavigation/takeaway-disabled.svg'
import deliveryDisabledIcon from 'assets/icons/bottomNavigation/delivery-disabled.svg'
import shopDisabledIcon from 'assets/icons/bottomNavigation/shop-disabled.svg'
// import mapDisabledIcon from 'assets/icons/bottomNavigation/map-disabled.svg'
import * as directoryActions from 'actions/components/directory'
import { goToShop } from 'helpers/redirect'
import moment from 'moment'
import system from '../../../services/api/system'

class BottomNavigation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      enableTakeaway: false,
      enableSDelivery: false,
      enableTakeawayRemark: "",
      enableSDeliveryRemark: "",
    }
    this.getTakeaway()
    this.getSDelivery()
  }

  handleOpenMap = () => {
    window.open(`https://www.google.com/maps?q=${this.props.merchant.address}`, '_blank')
  }

  getTakeaway = async () => {
    const takeaway = await system.getTakeaway()
    this.setState({ enableTakeaway: takeaway.enable })
    this.setState({ enableTakeawayRemark: takeaway.remark })
  }

  getSDelivery = async () => {
    const sDelivery = await system.getSDelivery()
    this.setState({ enableSDelivery: sDelivery.enable })
    this.setState({ enableSDeliveryRemark: sDelivery.remark })
  }

  render () {
    const { intl, classes, merchant, directory } = this.props
    if (!merchant || !merchant.setting) return null
    const takeawayText =  merchant.setting.defaultClientLanguage === 'en' ? 'Takeaway' : intl.formatMessage({ id: 'directory.bottomNavigation.takeaway' })
    const deliveryText = intl.formatMessage({ id: 'directory.bottomNavigation.delivery' })
    const shopText = intl.formatMessage({ id: 'directory.bottomNavigation.shop' })
    const mapText = intl.formatMessage({ id: 'directory.bottomNavigation.map' })
    const takwawayDisableText = intl.formatMessage({ id: 'directory.bottomNavigation.takeawayDisable' })

    const hasTakeawayOpening = Boolean(_.find(merchant.openingsWithSurcharge, d => _.find(d, o => o.takeaway === true)))
    const hasDeliveryOpening = Boolean(_.find(merchant.openingsWithSurcharge, d => _.find(d, o => o.storeDelivery === true)))
    const enableTakeawayButton = !merchant.takeawayDisabled && hasTakeawayOpening && this.state.enableTakeaway && !merchant.disabled
    const enableDeliveryButton = merchant.setting.storeDelivery && hasDeliveryOpening && this.state.enableSDelivery && !merchant.disabled
    const enableShopButton = merchant.setting.shop && merchant.shippings.find(s => s.type === DELIVERY_TYPE_SHOP && s.enabled)
    const xs = directory.display.scale === 'xs'
    const takeawayUnavailable = merchant.setting.defaultClientLanguage === 'en' ? takeawayText + ' - Unavailable' : takeawayText + takwawayDisableText

    return (
      <div className={classes.bottomNavigation}>
        <div className={classes.gridContainer}>

          {/* Takeaway Button */}
          {enableTakeawayButton
            ? (
              <div className={classes.gridItem} onClick={() => this.props.updateDisplay('takeaway', true)}>
                <div className={classes.icon}>
                  <img src={takeawayIcon} alt='takeaway_icon'/>
                </div>
                <p className={classes.buttonText}>
                  {merchant.setting.defaultClientLanguage === 'en'
                  ? 'Takeaway'
                  : takeawayText}</p>
              </div>
            )
            : (
              <div className={classes.gridItemDisable}>
                <div className={classes.icon}>
                  <img src={takeawayIcon} alt='takeaway_icon'/>
                </div>
                <p className={classes.buttonText}>{takeawayUnavailable}</p>
              </div>
            )
          }

          {/* Delivery Button */}
          {enableDeliveryButton
            ? (
              <div className={classes.gridItem} onClick={() => this.props.updateDisplay('storeDelivery', true)}>
                <div className={classes.icon}>
                  <img src={deliveryIcon} alt='delivery_icon'/>
                </div>
                <p className={classes.buttonText}>
                  {merchant.setting.defaultClientLanguage === 'en'
                  ? 'Delivery'
                  : deliveryText}</p>
              </div>
            )
            : (
              <div className={classes.gridItemDisable}>
                <div className={classes.icon}>
                  <img src={deliveryIcon} alt='delivery_icon'/>
                </div>
                <p className={classes.buttonText}>
                {merchant.setting.defaultClientLanguage === 'en'
                  ? 'Delivery'
                  : deliveryText}</p>
              </div>
            )
          }
          <div className={classes.remark}>{this.state.enableTakeawayRemark}</div>
          <div className={classes.remark}>{this.state.enableSDeliveryRemark}</div>
        </div>
      </div>
    )
  }
}

const styles = {
  bottomNavigation: {
    width: '100%',
    '& p': {
      margin: 5, // remove default margin of <p>
      letterSpacing: '0.025em',
    },
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '10px',
    justifyItems: 'center',
  },
  gridItem: {
    height: 60,
    maxWidth: 185,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    color: '#ffffff',
    borderRadius: '5px',
    background: '#FFAF02',
    justifyContent: 'center',
  },
  gridItemDisable: {
    height: 60,
    maxWidth: 185,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    color: '#ffffff',
    borderRadius: '5px',
    background: '#878787',
    justifyContent: 'center',
  },
  buttonText: {
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '16px',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '5px',
  },
  remark: {
    color: '#ffffff',
    fontSize: '16px',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    directory: state.directory,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(directoryActions, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(BottomNavigation)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/BottomNavigation.jsx